var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalIconOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.209,
    height: 18.084,
    viewBox: "0 0 14.209 18.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11767",
    "data-name": "Group 11767",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id_card",
    "data-name": "id card",
    transform: "translate(5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49535",
    "data-name": "Path 49535",
    d: "M17.271,2H6.938A1.938,1.938,0,0,0,5,3.938V18.147a1.938,1.938,0,0,0,1.938,1.938H17.271a1.938,1.938,0,0,0,1.938-1.938V3.938A1.938,1.938,0,0,0,17.271,2ZM14.042,17.5H10.167a.646.646,0,0,1,0-1.292h3.875a.646.646,0,1,1,0,1.292Zm.646-2.583H9.521a.646.646,0,1,1,0-1.292h5.167a.646.646,0,0,1,0,1.292Zm.646-3.229a.646.646,0,0,1-.646.646H9.521a.646.646,0,0,1-.646-.646V10.253a3.076,3.076,0,0,1,1.6-2.689,1.918,1.918,0,0,1-.31-1.043,1.938,1.938,0,1,1,3.875,0,1.918,1.918,0,0,1-.31,1.043,3.076,3.076,0,0,1,1.6,2.689Z",
    transform: "translate(-5 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49536",
    "data-name": "Path 49536",
    d: "M16.875,12.378v.789H13v-.789a1.8,1.8,0,0,1,1.794-1.794h.287A1.8,1.8,0,0,1,16.875,12.378ZM14.938,9.292a.646.646,0,1,0-.646-.646A.646.646,0,0,0,14.938,9.292Z",
    transform: "translate(-7.833 -4.125)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIconOne);
export default __webpack_public_path__ + "static/media/legal-icon-one.1e335ebb16188b953aa13b5879dc1576.svg";
export { ForwardRef as ReactComponent };